import { sample } from 'effector';
import { $activeFilters } from './stores.js';
import {
  changeActiveFilterEv,
  debounced,
  resetActiveFiltersEv,
} from './events.js';

$activeFilters.reset(resetActiveFiltersEv);

sample({
  source: $activeFilters,
  clock: [debounced, changeActiveFilterEv],
  fn: (source, clock) => {
    if (/zoom\d+?_hex/g.test(clock.field)) {
      if (source[clock.field].id === clock.value.id) {
        return { ...source, [clock.field]: { id: '', centerCoords: [] } };
      }
      return { ...source, [clock.field]: clock.value };
    }
    if (clock.field === 'excludedIndexes') {
      if (!clock.value) {
        return {
          ...source,
          excludedIndexes: [],
        };
      }
      if (typeof clock.value === 'string') {
        if (source[clock.field].includes(clock.value)) {
          return {
            ...source,
            excludedIndexes: source.excludedIndexes.filter(
              (item) => item !== clock.value
            ),
          };
        }
      } else if (
        clock.value.every((item) => source[clock.field].includes(item))
      ) {
        return {
          ...source,
          excludedIndexes: source.excludedIndexes.filter(
            (item) => !clock.value.includes(item)
          ),
        };
      }
      let addValue = clock.value;
      if (typeof clock.value === 'string') {
        addValue = [clock.value];
      }
      return {
        ...source,
        excludedIndexes: [...source.excludedIndexes, ...addValue],
      };
    }

    if (clock.field === 'gradient') {
      if (clock.value === null)
        return {
          ...source,
          gradient: [],
        };
      if (
        source.gradient.every(
          (item) => item.min !== clock.value.min && item.max !== clock.value.max
        )
      ) {
        return {
          ...source,
          gradient: [...source.gradient, clock.value],
        };
      }
      return {
        ...source,
        gradient: source.gradient.filter(
          (item) => item.min !== clock.value.min && item.max !== clock.value.max
        ),
      };
    }

    if (clock.field === 'chosen_metrics') {
      if (source.chosen_metrics.includes(clock.value)) {
        return {
          ...source,
          chosen_metrics: source.chosen_metrics.filter(
            (item) => item !== clock.value
          ),
        };
      }
      return {
        ...source,
        // FIXME For multiple metrics. Gotta rewrite calculateHexagonsByMetrics in hex utils
        // chosen_metrics: [...source.chosen_metrics, clock.value],
        chosen_metrics: [clock.value],
      };
    }

    if (source[clock.field] === clock.value) {
      return { ...source, [clock.field]: '' };
    }
    return { ...source, [clock.field]: clock.value };
  },
  target: $activeFilters,
});
